<template>
  <div class="d-post-poll-multiple-choice">
    <div
      v-for="(option, idx) in options"
      :key="idx"
      class="option"
    >
      <div class="grid-flex grid-middle grid-no-response">
        <div class="grid-item-shrink">
          <button
            class="button-grey button-icon button-sm button-close"
            :disabled="options.length < 3"
            title="Remove option"
            @click="removeOption(idx)"
          />
        </div>
        <div class="grid-item">
          <input
            v-model="option.text"
            class="input-full"
            placeholder="Add option..."
            type="text"
          >
        </div>
      </div>
    </div>

    <a
      title="Add option"
      @click="addOption"
    >Add option</a>
  </div>
</template>

<script>
import { POST_TYPES } from '@d-shared/config';

export default {
  props: {
    postInfo: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isLoadingData: false,
    options: [
      { text: null },
      { text: null },
    ],
  }),
  watch: {
    options: {
      deep: true,
      handler: function() {
        this.savePostInfo();
      },
    },
  },
  beforeDestroy() {
    this.clearPostInfo();
  },
  mounted() {
    this.setEditingContent();
  },
  methods: {
    addOption() {
      this.options.push({ text: null });
    },

    clearPostInfo() {
      this.$set(this.postInfo, 'multipleChoiceOptions', null);
    },

    removeOption(idx) {
      this.options.splice(idx, 1);
    },

    setEditingContent() {
      if (!this.postInfo.multipleChoiceOptions) {
        return;
      }

      this.$set(this, 'isLoadingData', true);

      const editingOptions = [];
      this.postInfo.multipleChoiceOptions.forEach(o => {
        editingOptions.push({ text: o });
      });
      this.$set(this, 'options', editingOptions);

      this.$set(this, 'isLoadingData', false);
    },

    savePostInfo() {
      const isOptionMissing = this.options.find(o => !o.text);
      if (isOptionMissing) {
        this.clearPostInfo();
        return;
      }

      this.$set(this.postInfo, 'multipleChoiceOptions', this.options.map(o => o.text));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-post-poll-multiple-choice {
  .option {
    border: $border-width-base solid getColor($grey, medium);
    border-radius: $border-radius-base;
    padding: 0 $_1em;
    margin: $_1em 0;

    input {
      border: none;
    }
  }
}
</style>
